import React from "react"
import Card from "./Card"
import Header from "../Header/Header"
import { project } from "../../portfolio"
function Service() {
  return (
    <div>
      <Header title="Projects" />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-lg-10 col-md-12 col-sm-12 mx-auto">
            <div className="row gy-4">
              {project.project_data.map((val, idx) => {
                return (
                  <Card
                    key={idx}
                    imgsrc={val.imgsrc}
                    title={val.title}
                    Date={val.Date}
                    stacks={val.stacks}
                    video={val.video}
                    content={val.content}
                    live={val.live}
                    github={val.github}
                  />
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Service
